import { render } from "./AdmHorarios.vue?vue&type=template&id=138c95cb&scoped=true&ts=true"
import script from "./AdmHorarios.vue?vue&type=script&lang=ts"
export * from "./AdmHorarios.vue?vue&type=script&lang=ts"

import "./AdmHorarios.vue?vue&type=style&index=0&id=138c95cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138c95cb"]])

export default __exports__